import React from 'react'
import styles from './index.module.scss'

export default function Card({ children, className }) {
    return (
        <div className={styles.wrapper + ' p-2' + (className ? ' ' + className : '')}>
            { children }
        </div>
    )
}